import { Box, Typography } from "@mui/material"

import { Accordion, Grid, type FC } from ".."

export type AccordionProps = {
  title?: string
  items: {
    title: string
    text: string
  }[]
}

const SectionAccordion: FC<AccordionProps> = ({ title, items }) => {
  return (
    <Grid component="article" sx={{ rowGap: 10 }}>
      <Box gridColumn={{ xs: "1 / -1", lg: "2 / -2" }}>
        {title && (
          <Typography variant="heading.lg" component="h2" mb={{ xs: 5, md: 20 }}>
            {title}
          </Typography>
        )}
        <Accordion items={items} startOpen />
      </Box>
    </Grid>
  )
}

export default SectionAccordion
